export const MS_PER_DAY = 24 * 60 * 60 * 1000

export type DateRange = {
  from?: string
  to?: string
}

// Converts `YYYY-MM-DD` date-picker values into inclusive start/end-of-day ISO
// timestamps (local time). An empty string maps to `undefined` so an unset
// bound becomes an open range.
export function customToRange(from: string, to: string): DateRange {
  return {
    from: from ? new Date(`${from}T00:00:00`).toISOString() : undefined,
    to: to ? new Date(`${to}T23:59:59.999`).toISOString() : undefined,
  }
}

// Builds a `{ from, to }` window spanning the last `days` days up to now.
export function relativeRangeFromDays(days: number): DateRange {
  const to = new Date()
  const from = new Date(to.getTime() - days * MS_PER_DAY)
  return { from: from.toISOString(), to: to.toISOString() }
}
